import { Search, FileText, PenTool } from "lucide-react";

import { useTranslation } from "react-i18next";
import { pickBg, pickContent } from "@/assets/generated";
import { MobileFeatures } from "./mobile/mobile-features";
import { AuroraOrb } from "@/components/vision/aurora-orb";
import { Reveal, RevealStagger } from "@/components/vision/reveal";
import { EditorialHeading } from "./editorial-heading";

export function FeaturesSection() {
  const { t } = useTranslation();
  const features = [
    {
      icon: Search,
      title: t("features.items.research.title"),
      desc: t("features.items.research.desc"),
      img: pickContent(45),
      bg: pickBg(0),
    },
    {
      icon: FileText,
      title: t("features.items.analysis.title"),
      desc: t("features.items.analysis.desc"),
      img: pickContent(41),
      bg: pickBg(7),
    },
    {
      icon: PenTool,
      title: t("features.items.drafting.title"),
      desc: t("features.items.drafting.desc"),
      img: pickContent(36),
      bg: pickBg(14),
    },
  ];
  return (
    <>
    <div className="md:hidden"><MobileFeatures /></div>
    <section id="features" className="relative overflow-hidden bg-background py-24 sm:py-32 hidden md:block">
      <AuroraOrb className="left-[-10%] top-[10%]" color="violet" size={420} />
      <AuroraOrb className="right-[-8%] bottom-[5%]" color="magenta" size={360} delay={4} />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <EditorialHeading
          index="No. 01"
          eyebrow={t("features.eyebrow")}
          title={t("features.title")}
          subtitle={t("features.subtitle")}
        />
        <RevealStagger
          className="mt-12 -mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-4 hide-scrollbar md:mt-16 md:mx-0 md:grid md:grid-cols-3 md:gap-6 md:overflow-visible md:px-0 md:pb-0"
          stagger={0.12}
          y={32}
          blur={10}
        >
          {features.map((f) => (
            <div
              key={f.title}
              className="group relative shrink-0 snap-center w-[85%] overflow-hidden rounded-3xl border border-border bg-card transition-all duration-500 hover:border-accent/40 hover:shadow-xl hover:-translate-y-1 md:w-auto md:rounded-2xl"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-muted">
                <img src={f.img} alt={f.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" decoding="async" />
                <div className="absolute inset-0 bg-gradient-to-t from-card via-card/40 to-transparent" />
              </div>
              <div className="relative p-7 md:p-8">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3">
                  <f.icon className="h-6 w-6" />
                </div>
                <h3 className="mt-6 font-display text-2xl font-semibold text-foreground">{f.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{f.desc}</p>
              </div>
            </div>
          ))}
        </RevealStagger>
      </div>
    </section>
    </>
  );
}
